import { render } from "./Fort.vue?vue&type=template&id=5ddbdd3f&scoped=true"
import script from "./Fort.vue?vue&type=script&lang=js"
export * from "./Fort.vue?vue&type=script&lang=js"

import "./Fort.vue?vue&type=style&index=0&id=5ddbdd3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddbdd3f"]])

export default __exports__